module.exports = __webpack_public_path__ + "static/media/profile.a315a3c8.jpg";